import type { MutableRefObject } from 'react';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConnectionStatusEnum, type CurrencyConversionRate, type Security } from '../types';
import { isCFD, isFuture, isMultileg, isPerpetualSwap, isSpot } from '../utils';
import { useHomeCurrencyRate } from './useHomeCurrencyRate';
import { useObservableRef } from './useObservable';

export function useConversionRef(
  currency: string | undefined,
  symbol: string | undefined,
  security: Security | undefined
): MutableRefObject<CurrencyConversionRate | undefined> {
  const currencyConversion = useHomeCurrencyRate(currency);
  const symbolConversion = useHomeCurrencyRate(symbol);

  return useObservableRef(
    () =>
      combineLatest([symbolConversion, currencyConversion]).pipe(
        map(([sc, cc]) => {
          // Prioritize Currency Conversion for ProductTypeEnum.Spot, Multileg, Perps or Futures for non-contract orders (currency is set) and CFDs
          if (
            currency &&
            (isSpot(security) ||
              isMultileg(security) ||
              isPerpetualSwap(security) ||
              isFuture(security) ||
              isCFD(security))
          ) {
            return cc;
          }
          return sc?.Status === ConnectionStatusEnum.Online ? sc : cc;
        })
      ),
    [symbolConversion, currencyConversion, security, currency]
  );
}
